module.exports = __webpack_public_path__ + "a348c8e7b1c4a691683da016a97eec55.MP3";